<template>
  <nav aria-label="Page navigation">
      <ul class="pagination justify-content-between">
        <li data-component="prevLink" :class="prevPageNumber ? 'page-item' : 'page-item disabled'">
          <a class="page-link" href="#" @click="navigate(prevPageNumber, $event)">
            <span aria-hidden="true">&laquo;</span>
            Previous</a>
        </li>
        <li data-component="nextLink" :class="nextPageNumber ? 'page-item' : 'page-item disabled'">
          <a class="page-link" href="#" @click="navigate(nextPageNumber, $event)">
            Next
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
</template>

<script>


export default {
  name: "PageNavigation",
  props: ['prevPageNumber', 'nextPageNumber'],
  methods: {
    navigate(pageNumber, event){
      event.preventDefault();
      this.$emit('navigate', { pageNumber } );
    }
  }
};
</script>
<style>

</style>
